exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-change[data-v-22e52835],.v-app[data-v-22e52835],.v-application[data-v-22e52835],body[data-v-22e52835],html[data-v-22e52835]{font-family:ABCFavorit,system-ui,sans-serif!important}.cloaked-alert[data-v-22e52835]{display:block;position:fixed!important;z-index:10;bottom:35px;right:25px;padding:10px 20px}a[data-v-22e52835]:hover{cursor:pointer}", ""]);

// exports
